(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-product-viewers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-product-viewers')) {
    customElements.define('sb-product-viewers', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.update();
        this.timer = setInterval(() => {
          if (!document.hidden) this.update();
        }, 20000);
      }
      update() {
        const count = this.querySelector('[data-viewer-count]');
        if (!count) return;
        const product = Number(this.dataset.product.slice(-4));
        const slot = Math.floor(Date.now() / 20000);
        const phase = (slot + product) % 16;
        const value = 8 + (product % 5) + (phase <= 8 ? phase : 16 - phase);
        count.textContent = String(value);
      }
      stop() {
        if (this.timer) clearInterval(this.timer);
      }
      disconnectedCallback() {
        this.stop();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
